import { Card } from '../../components/home/card';

const LAST_UPDATED = 'February 6, 2026';

export function PrivacyPolicyRoute() {
    return (
        <div className="mx-auto w-full max-w-3xl">
            <Card className="animate-fade-up">
                <header className="space-y-3">
                    <p className="text-xs font-semibold uppercase tracking-[0.35em] text-secondary">
                        Privacy
                    </p>
                    <h1 className="text-3xl font-semibold leading-tight text-foreground md:text-4xl">
                        Privacy Policy
                    </h1>
                    <p className="text-xs text-secondary">
                        Last updated: <span className="font-semibold text-foreground/80">{LAST_UPDATED}</span>
                    </p>
                </header>

                <div className="mt-6 space-y-6 text-sm leading-relaxed text-secondary">
                    <p>
                        This Privacy Policy explains how UNVOX (&quot;we&quot;, &quot;us&quot;) collects, uses, and
                        shares information when you use unvox.ai (the &quot;Service&quot;).
                    </p>

                    <section className="space-y-2">
                        <h2 className="text-base font-semibold tracking-tight text-foreground">Information We Collect</h2>
                        <ul className="list-disc space-y-2 pl-5">
                            <li>
                                <span className="font-semibold text-foreground/80">Contact information</span>:
                                your email address, which we use to deliver your download link and provide support.
                            </li>
                            <li>
                                <span className="font-semibold text-foreground/80">Content you submit</span>:
                                audio files you upload and/or YouTube URLs you provide for processing, plus the resulting
                                outputs we generate for you.
                            </li>
                            <li>
                                <span className="font-semibold text-foreground/80">Usage and technical data</span>:
                                basic logs and diagnostics (for example, IP address, browser information, and timestamps)
                                used to operate, secure, and improve the Service.
                            </li>
                            <li>
                                <span className="font-semibold text-foreground/80">Payment information</span>:
                                payments are processed by Stripe. We do not store full payment card details on our servers.
                            </li>
                        </ul>
                    </section>

                    <section className="space-y-2">
                        <h2 className="text-base font-semibold tracking-tight text-foreground">How We Use Information</h2>
                        <ul className="list-disc space-y-2 pl-5">
                            <li>To provide the Service: create previews, process your audio, and deliver results.</li>
                            <li>To communicate with you about your job status and delivery.</li>
                            <li>To prevent abuse, troubleshoot issues, and keep the Service reliable and secure.</li>
                            <li>To improve performance and user experience (using aggregated insights where possible).</li>
                        </ul>
                    </section>

                    <section className="space-y-2">
                        <h2 className="text-base font-semibold tracking-tight text-foreground">How We Share Information</h2>
                        <p>
                            We share information only as needed to provide the Service, for example with service providers
                            that help us process payments, store files, and send email. These providers are authorized to
                            use information only to perform services on our behalf.
                        </p>
                        <p>
                            We may also share information if required to comply with applicable law or to protect the
                            rights, safety, and security of UNVOX, our users, or the public.
                        </p>
                    </section>

                    <section className="space-y-2">
                        <h2 className="text-base font-semibold tracking-tight text-foreground">Retention</h2>
                        <p>
                            We retain your email address and job-related metadata as needed to operate the Service.
                            Uploaded files and previews are typically deleted within 7 days. Paid outputs are typically deleted
                            within 14 days. Job records may be retained longer for support, fraud prevention, and to operate the
                            Service.
                        </p>
                    </section>

                    <section className="space-y-2">
                        <h2 className="text-base font-semibold tracking-tight text-foreground">Your Choices</h2>
                        <p>
                            If you would like to request access to or deletion of information associated with a job,
                            contact us by replying to the delivery email you received. Please include your job ID so we
                            can locate the relevant records.
                        </p>
                    </section>

                    <section className="space-y-2">
                        <h2 className="text-base font-semibold tracking-tight text-foreground">Changes</h2>
                        <p>
                            We may update this Privacy Policy from time to time. We will post the updated version on this
                            page and revise the &quot;Last updated&quot; date above.
                        </p>
                    </section>
                </div>
            </Card>
        </div>
    );
}
